import React from 'react';
import IconComponent from '../IconComponents/IconComponent';
import { Title } from '../../ui/Title';
import { Button } from '../../ui/Button';
import { useNavigate } from 'react-router-dom';

interface IRedirectProps {
    count: number;
    title: string;
    isLoggedIn: boolean;
    navigateTo: string;
}

export const Redirect: React.FC<IRedirectProps> = ({ count, title, isLoggedIn, navigateTo }) => {
    const navigate = useNavigate();

    const redirectPage = (route: string) => {
        navigate(route, { state: location.pathname });
    };

    return (
        <div className="redirect">
            <IconComponent size={10} iconName={'Redirect'} />
            <div className="redirect__text-group">
                <Title text={`User is ${isLoggedIn ? 'already' : 'not'} logged in.`} size={'xl'} />
                <p className="redirect__text">
                    {`You're being redirected to `}
                    <span className="redirect__text--accent">{title}</span>
                    {` page, it may takes up to `}
                    <span className="redirect__text--count">{count}</span> seconds
                </p>
            </div>
            <Button label={`Go to ${title}`} role={'accent-blue'} size={'medium'} stretch={true} func={() => redirectPage(navigateTo)} />
        </div>
    );
};
